import { FunctionComponent } from 'react';
import { Size } from '@/types';
import { isEmbroideryMode } from '@/utils/params';
import { scaleSize } from '@/model/configuration/scaleSize';
import './MaxSizeHint.scss';

interface MaxSizeHintProps {
  size: Size;
  currentScale: number;
  maxScale: number;
  active: boolean;
}

export const MaxSizeHint: FunctionComponent<MaxSizeHintProps> = ({
  size,
  currentScale,
  maxScale,
  active,
}) => {
  if (!size || !size.width || isEmbroideryMode()) {
    return null;
  }

  const currentSize = scaleSize(size, currentScale);
  const maxSize = scaleSize(size, maxScale);

  return (
    <g className="configuration-max-size">
      <rect
        x={(currentSize.width - maxSize.width) / 2}
        y={(currentSize.height - maxSize.height) / 2}
        width={maxSize.width}
        height={maxSize.height}
        opacity="0.5"
        strokeWidth={active ? 1 : 0}
      />
    </g>
  );
};
